import axios from "axios";
import { toast } from "react-toastify";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Add a request interceptor
instance.interceptors.request.use(
  config => {
    const app = process.env.REACT_APP_NAME;
    let token;
    let env = process.env.REACT_APP_ENV;
    if (localStorage.getItem(app)) {
      const redux = JSON.parse(localStorage.getItem(app));
      if (redux.auth && redux.auth.token) {
        token = redux.auth.token;
      }
    } else if (window.token) {
      token = window.token;
    }

    config.headers = {
      Accept: "application/json",
    };
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (env) {
      config.headers.env = env;
    }

    return config;
  },
  error => Promise.reject(error),
);

// Add a response interceptor
instance.interceptors.response.use(
  response => {
    // Return JSON data
    if (response.data) {
      if (!response.data.result.ok) {
        toast.error(response.data.result.message);
      }
      return response.data;
    }
    return response;
  },
  error => {
    // Attempt to get the actual error returned from API
    const err =
      (error.response && error.response.data && error.response.data) || error;

    return Promise.reject(err); // Propagate rejection back to caller
  },
);

export default instance;
